import { Spinner_default } from "./chunk-R5WT33YN.js";
import { renderIcon } from "./chunk-EIVCXCZI.js";
import { __objRest, __spreadProps, __spreadValues } from "./chunk-ORMEWXMH.js";

// src/elements/Button/Button.tsx
import { forwardRef, useMemo } from "react";
import clsx from "clsx";
import { jsx, jsxs } from "react/jsx-runtime";
var DEFAULT_COMPONENT = "button";
var BUTTON_CLASSNAME_MAP = {
  variant: {
    primary: "pd-button--primary",
    secondary: "pd-button--secondary",
    tertiary: "pd-button--tertiary",
    dim: "pd-button--tertiary",
    white: "pd-button--white",
    "white-circle": "pd-button--white pd-p-0"
  },
  size: {
    md: "pd-h-12 pd-px-4 pd-text-md",
    lg: "pd-h-16 pd-px-6 pd-text-xl"
  }
};
var Button = forwardRef((_a, ref) => {
  var _b = _a,
    {
      as,
      children,
      variant = "primary",
      size = "md",
      iconBefore: iconBeforeProp,
      iconAfter: iconAfterProp,
      screenReaderLabel,
      type = "button",
      isLoading,
      disabled,
      className,
      "aria-disabled": ariaDisabled
    } = _b,
    rest = __objRest(_b, ["as", "children", "variant", "size", "iconBefore", "iconAfter", "screenReaderLabel", "type", "isLoading", "disabled", "className", "aria-disabled"]);
  const Component = as || DEFAULT_COMPONENT;
  const iconBefore = useMemo(() => iconBeforeProp && renderIcon(iconBeforeProp), [iconBeforeProp]);
  const iconAfter = useMemo(() => iconAfterProp && renderIcon(iconAfterProp), [iconAfterProp]);
  return /* @__PURE__ */jsxs(Component, __spreadProps(__spreadValues({
    ref,
    disabled,
    "aria-disabled": disabled ? "true" : ariaDisabled,
    type,
    className: clsx("pd-button", BUTTON_CLASSNAME_MAP.variant[variant], BUTTON_CLASSNAME_MAP.size[size], variant === "white-circle" && size === "md" && "pd-w-12", variant === "white-circle" && size === "lg" && "pd-w-16", className)
  }, rest), {
    children: [screenReaderLabel && /* @__PURE__ */jsx("span", {
      className: "pd-sr-only",
      children: screenReaderLabel
    }), !isLoading && iconBefore, isLoading && /* @__PURE__ */jsx(Spinner_default, {}), children, iconAfter]
  }));
});
var StoryButton = args => /* @__PURE__ */jsx(Button, __spreadValues({}, args));
var Button_default = Button;
export { BUTTON_CLASSNAME_MAP, StoryButton, Button_default };